import { CustomerOverride, asCustomerOverride } from "./CustomerOverride.js";
export class Customer {
    id = null;
    name = null;
    dateCreated = null;
    billingAddress = null;
    deliveryAddress = null;
    deliveryUsesDifferentAddress = false;
    userMustNotEditAddresses = false;
    phone = null;
    email = null;
    companyId = null;
    note = null;
    sortOrder = 0;
    loginToken = null;
    loginTokenExpirationDate = null;
    checkoutNotice = null;
    orderOptionsNotice = null;
    frontpageNotice = null;
    disabled = false;
    enableVouchers = false;
    autoAppliedDiscounts = null;
    //per customer overrides of the equally named sales zone options. 'inherit' keeps
    //whatever the zone the customer orders in allows, 'yes'/'no' replace it
    enableOnlinePayment = CustomerOverride.inherit;
    enableOfflinePayment = CustomerOverride.inherit;
    enableInvoicePayment = CustomerOverride.inherit;
    enableDelivery = CustomerOverride.inherit;
    enablePickup = CustomerOverride.inherit;
    categoryVisibilityRule = null;
    categoryVisibilityConfig = null;
    pagesVisibilityRule = null;
    pagesVisibilityConfig = null;
    storiesVisibilityRule = null;
    storiesVisibilityConfig = null;
    constructor(id, data) {
        this.id = id || null;
        let definedKeys = Object.keys(this).filter((key) => key != "id");
        for (let key in data) {
            let value = data[key];
            let keyIsDefinedOnInstance = definedKeys.includes(key);
            if (keyIsDefinedOnInstance) {
                if (value) {
                    //replace all firebase dates with real dates
                    if (value.seconds && value.toDate) {
                        value = value.toDate();
                    }
                }
                Object.assign(this, { [key]: value });
            }
        }
        //keep the tri-state fields honest: documents written before the setting existed
        //(and anything unrecognised) mean inherit
        this.enableOnlinePayment = asCustomerOverride(this.enableOnlinePayment);
        this.enableOfflinePayment = asCustomerOverride(this.enableOfflinePayment);
        this.enableInvoicePayment = asCustomerOverride(this.enableInvoicePayment);
        this.enableDelivery = asCustomerOverride(this.enableDelivery);
        this.enablePickup = asCustomerOverride(this.enablePickup);
    }
    getPublicInfo() {
        let data = JSON.parse(JSON.stringify(this));
        return {
            id: data.id,
            name: data.name,
            billingAddress: data.billingAddress,
            deliveryAddress: data.deliveryAddress,
            deliveryUsesDifferentAddress: data.deliveryUsesDifferentAddress,
            phone: data.phone,
            email: data.email,
            companyId: data.companyId,
            checkoutNotice: data.checkoutNotice,
            orderOptionsNotice: data.orderOptionsNotice,
            frontpageNotice: data.frontpageNotice,
            userMustNotEditAddresses: data.userMustNotEditAddresses,
            enableVouchers: data.enableVouchers,
            autoAppliedDiscounts: data.autoAppliedDiscounts,
            enableOnlinePayment: data.enableOnlinePayment,
            enableOfflinePayment: data.enableOfflinePayment,
            enableInvoicePayment: data.enableInvoicePayment,
            enableDelivery: data.enableDelivery,
            enablePickup: data.enablePickup,
            categoryVisibilityRule: data.categoryVisibilityRule,
            categoryVisibilityConfig: data.categoryVisibilityConfig,
            pagesVisibilityRule: data.pagesVisibilityRule,
            pagesVisibilityConfig: data.pagesVisibilityConfig,
            storiesVisibilityRule: data.storiesVisibilityRule,
            storiesVisibilityConfig: data.storiesVisibilityConfig
        };
    }
}
